const deleteCookie = (name) => {
    if (window && window.document) {
        document.cookie = `${name}=;Path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
};

export default deleteCookie;

